<template>
	<div class="page-container">
		<div class="header-title">
			<van-icon name="arrow-left" class="back-icon" @click="$router.back()" /> 签约协议
		</div>
		<div class="content">
			<div class="image-container">
				<img :src="signImg" alt="协议图片" />
				<div class="signature-area" @click="showSignature = true">
					<div v-if="!signatureData" class="sign-placeholder">点击签名</div>
					<img v-else :src="signatureData" alt="签名" class="signature-image" />
				</div>
			</div>
			
			<!-- 签名弹窗 -->
			<van-popup 
				v-model="showSignature" 
				position="bottom" 
				round 
				:close-on-click-overlay="false"
				:style="{ height: '50%' }"
				@opened="initCanvas"
			>
				<div class="signature-popup">
					<div class="popup-header">
						<span class="popup-title">请签名</span>
						<div class="popup-actions">
							<van-button size="small" @click="clearSignature">清空</van-button>
							<van-button size="small" @click="cancelSignature">取消</van-button>
							<van-button size="small" type="primary" @click="confirmSignature">确定</van-button>
						</div>
					</div>
					<div class="signature-canvas-container">
						<canvas 
							ref="signatureCanvas" 
							class="signature-canvas"
							@mousedown="startDrawing"
							@mousemove="draw"
							@mouseup="stopDrawing"
							@mouseleave="stopDrawing"
							@touchstart="handleTouchStart"
							@touchmove="handleTouchMove"
							@touchend="handleTouchEnd"
							@touchcancel="handleTouchEnd"
						></canvas>
					</div>
				</div>
			</van-popup>
			
			<!-- 提交按钮 -->
			<div class="submit-section" v-if="signatureData">
				<van-button 
					type="primary" 
					block 
					round 
					size="large"
					@click="submitSignature"
					:loading="submitting"
				>
					{{ submitting ? '提交中...' : '提交并继续' }}
				</van-button>
			</div>
		</div>
	</div>
</template>

<script>
	import Fetch from '../../utils/fetch';
	import signImg from '@/assets/withdrawBankCard/sign.png';
	import signBeforeImg from '@/assets/withdrawBankCard/sign_before.png';
	import signAfterImg from '@/assets/withdrawBankCard/sign_after.png';
	
	export default {
		name: 'signingAgreement',
		data() {
			return {
				signImg: signImg,
				signBeforeImg: signBeforeImg,
				signAfterImg: signAfterImg,
				showSignature: false,
				signatureData: null,
				submitting: false,
				
				// 签名板相关
				isDrawing: false,
				lastX: 0,
				lastY: 0,
				ctx: null,
				dpr: 1,
				canvasRect: null,
				canvas: null,
				hasTouchMoved: false // 用于判断是否触发了滑动返回
			}
		},
		created() {
			this.$parent.footer('signingAgreement', false);
		},
		methods: {
			// 初始化画布
			initCanvas() {
				this.$nextTick(() => {
					this.canvas = this.$refs.signatureCanvas;
					if (!this.canvas) return;
					
					// 获取画布的DOM元素和尺寸
					const canvasElement = this.canvas;
					const rect = canvasElement.getBoundingClientRect();
					
					// 设置画布显示尺寸
					canvasElement.width = rect.width;
					canvasElement.height = rect.height;
					canvasElement.style.width = rect.width + 'px';
					canvasElement.style.height = rect.height + 'px';
					
					// 获取2D上下文
					this.ctx = canvasElement.getContext('2d');
					
					// 设置绘图样式
					this.ctx.lineWidth = 3;
					this.ctx.lineCap = 'round';
					this.ctx.lineJoin = 'round';
					this.ctx.strokeStyle = '#000000'; // 黑色
					this.ctx.fillStyle = '#ffffff'; // 白色背景
					
					// 清空并填充白色背景
					this.ctx.fillRect(0, 0, rect.width, rect.height);
					
					// 保存画布矩形信息用于坐标计算
					this.canvasRect = rect;
					
					console.log('画布初始化完成，尺寸:', rect.width, 'x', rect.height);
				});
			},
			
			// 获取相对坐标
			getRelativeCoordinates(e) {
				if (!this.canvas || !this.canvasRect) return { x: 0, y: 0 };
				
				let clientX, clientY;
				
				// 处理触摸事件
				if (e.type.includes('touch')) {
					const touch = e.touches[0];
					clientX = touch.clientX;
					clientY = touch.clientY;
				} 
				// 处理鼠标事件
				else {
					clientX = e.clientX;
					clientY = e.clientY;
				}
				
				// 计算相对于画布的坐标
				const rect = this.canvas.getBoundingClientRect();
				const x = clientX - rect.left;
				const y = clientY - rect.top;
				
				return { x, y };
			},
			
			// 开始绘制（鼠标）
			startDrawing(e) {
				e.preventDefault();
				const pos = this.getRelativeCoordinates(e);
				this.isDrawing = true;
				this.lastX = pos.x;
				this.lastY = pos.y;
				
				// 开始新路径
				this.ctx.beginPath();
				this.ctx.moveTo(this.lastX, this.lastY);
				
				console.log('开始绘制，起点:', this.lastX, this.lastY);
			},
			
			// 处理触摸开始
			handleTouchStart(e) {
				// 阻止默认行为和冒泡，防止触发滑动返回
				e.preventDefault();
				e.stopPropagation();
				
				const pos = this.getRelativeCoordinates(e);
				this.isDrawing = true;
				this.lastX = pos.x;
				this.lastY = pos.y;
				this.hasTouchMoved = false;
				
				// 开始新路径
				this.ctx.beginPath();
				this.ctx.moveTo(this.lastX, this.lastY);
				
				console.log('触摸开始绘制，起点:', this.lastX, this.lastY);
			},
			
			// 绘制（鼠标）
			draw(e) {
				if (!this.isDrawing) return;
				e.preventDefault();
				
				const pos = this.getRelativeCoordinates(e);
				const x = pos.x;
				const y = pos.y;
				
				// 绘制线条
				this.ctx.lineTo(x, y);
				this.ctx.stroke();
				
				// 更新最后坐标
				this.lastX = x;
				this.lastY = y;
			},
			
			// 处理触摸移动
			handleTouchMove(e) {
				if (!this.isDrawing) return;
				
				// 阻止默认行为和冒泡，防止触发滑动返回
				e.preventDefault();
				e.stopPropagation();
				
				this.hasTouchMoved = true;
				
				const pos = this.getRelativeCoordinates(e);
				const x = pos.x;
				const y = pos.y;
				
				// 绘制线条
				this.ctx.lineTo(x, y);
				this.ctx.stroke();
				
				// 更新最后坐标
				this.lastX = x;
				this.lastY = y;
			},
			
			// 处理触摸结束
			handleTouchEnd(e) {
				if (e) {
					// 阻止默认行为和冒泡
					e.preventDefault();
					e.stopPropagation();
				}
				
				if (this.isDrawing) {
					this.isDrawing = false;
					this.ctx.closePath();
					console.log('停止绘制');
				}
			},
			
			// 停止绘制（用于鼠标）
			stopDrawing() {
				if (this.isDrawing) {
					this.isDrawing = false;
					this.ctx.closePath();
					console.log('停止绘制');
				}
			},
			
			// 清空签名
			clearSignature() {
				if (!this.canvas || !this.ctx || !this.canvasRect) return;
				
				// 清空画布
				this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
				
				// 重新填充白色背景
				this.ctx.fillStyle = '#ffffff';
				this.ctx.fillRect(0, 0, this.canvasRect.width, this.canvasRect.height);
				
				// 重置画笔样式
				this.ctx.strokeStyle = '#000000';
				this.ctx.lineWidth = 3;
				this.ctx.lineCap = 'round';
				this.ctx.lineJoin = 'round';
			},
			
			// 取消签名
			cancelSignature() {
				this.clearSignature();
				this.showSignature = false;
			},
			
			// 确认签名
			confirmSignature() {
				if (!this.canvas) return;
				
				// 检查是否有绘制内容
				const imageData = this.ctx.getImageData(0, 0, this.canvas.width, this.canvas.height);
				let hasContent = false;
				
				// 检查是否有非白色像素
				for (let i = 0; i < imageData.data.length; i += 4) {
					const r = imageData.data[i];
					const g = imageData.data[i + 1];
					const b = imageData.data[i + 2];
					
					// 如果不是白色（允许很小的误差）
					if (r < 250 || g < 250 || b < 250) {
						hasContent = true;
						break;
					}
				}
				
				if (!hasContent) {
					this.$toast('请先签名');
					return;
				}
				
				// 将画布内容转换为base64
				this.signatureData = this.canvas.toDataURL('image/png');
				this.showSignature = false;
				console.log('签名确认，base64长度:', this.signatureData.length);
			},
			
			// 提交签名
			async submitSignature() {
				if (!this.signatureData) {
					this.$toast('请先完成签名');
					return;
				}
				
				this.submitting = true;
				this.$router.push({
					path: '/onlinePayment',
					query: {
						id: 1
					}
				});
			}
		}
	}
</script>

<style lang="less" scoped>
	.page-container {
		height: 100vh;
		background-image: url('../../assets/withdrawBankCard/sign_bg.png');
		background-size: contain;
		background-position: center;
		position: relative;
		/* 防止页面滚动 */
		overflow: hidden;
	}

	.header-title {
		position: relative;
		z-index: 1;
		width: 100%;
		text-align: center;
		font-size: 4.8vw;
		font-weight: 600;
		padding: 4vw 0;
		background: linear-gradient(135deg,#e83a3a,#c41e17);
		box-shadow: 0 1.06667vw 3.2vw rgba(0, 0, 0, .05);
		color: #ffd08e;
		border-bottom: 1px solid rgba(0, 0, 0, .05);

		.back-icon {
			position: absolute;
			left: 4vw;
			top: 50%;
			transform: translateY(-50%);
			font-size: 5.33333vw;
			color: #fff;
			/* 增加触摸区域防止误触 */
			padding: 2vw;
			z-index: 100;
		}
	}
	
	.content {
		height: calc(100vh - 13vw);
		overflow: auto;
		-webkit-overflow-scrolling: touch;
		
		.image-container {
			position: relative;
			width: 100%;
			
			img {
				width: 100%;
				display: block;
			}
			
			.signature-area {
				position: absolute;
				bottom: 17vw;
				right: 8vw;
				width: 30vw;
				height: 10vw;
				border: 1px dashed #e83a3a;
				border-radius: 1vw;
				background: rgba(255, 255, 255, 0.9);
				display: flex;
				align-items: center;
				justify-content: center;
				cursor: pointer;
				z-index: 2;
				
				.sign-placeholder {
					color: #e83a3a;
					font-size: 3.5vw;
				}
				
				.signature-image {
					width: 100%;
					height: 100%;
					object-fit: contain;
				}
			}
		}
		
		.signature-popup {
			height: 100%;
			display: flex;
			flex-direction: column;
			
			.popup-header {
				flex-shrink: 0;
				display: flex;
				justify-content: space-between;
				align-items: center;
				padding: 4vw;
				border-bottom: 1px solid #eee;
				
				.popup-title {
					font-size: 4.5vw;
					font-weight: 600;
					color: #333;
				}
				
				.popup-actions {
					display: flex;
					gap: 2vw;
					
					.van-button {
						font-size: 3.5vw;
					}
				}
			}
			
			.signature-canvas-container {
				flex: 1;
				width: 100%;
				padding: 4vw;
				background: #f5f5f5;
				
				.signature-canvas {
					width: 100%;
					height: 100%;
					background: #fff;
					border: 1px solid #ddd;
					border-radius: 2vw;
					touch-action: none; /* 禁用所有浏览器触摸行为 */
					-webkit-user-select: none;
					-moz-user-select: none;
					-ms-user-select: none;
					user-select: none;
				}
			}
		}
		
		.submit-section {
			margin-top: 8vw;
			padding: 0 4vw 8vw;
			
			.van-button {
				font-size: 4.2vw;
				height: 12vw;
			}
		}
	}
	
	/* 修复弹窗样式 */
	.van-popup--bottom {
		touch-action: none; /* 禁用弹窗内的触摸行为 */
	}
</style>